import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectInput from '../../../common/inputs/select-input';
import { withEditSpot } from '../../../../../spots/hoc/withEditSpot';

var DEFAULT_OPTION = { value: -1, text: 'Select category...' };

const displayName = 'CategoriesInput';

class CategoriesInput extends Component {
  constructor(props, context) {
    super(props, context);
    var category = props.categoryId ? this.getCategoryById(props.categoryId) : null;
    var subCategory = props.subCategoryId
      ? this.getSubCategoryById(category, props.subCategoryId)
      : null;
    this.state = {
      error: null,
      success: null,
      category,
      subCategory,
      isSelected: props.categoryId ? true : false,
      validate: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var state = {};
    if (!nextProps.edit) {
      state.error = 'Please select category';
    }
    if (nextProps.categoryId !== this.props.categoryId) {
      state.category = this.getCategoryById(nextProps.categoryId);
      state.isSelected = true;
      state.success = null;
      state.error = 'Please select subcategory';
    }
    if (nextProps.subCategoryId !== this.props.subCategoryId) {
      state.category = state.category || this.getCategoryById(nextProps.categoryId);
      state.subCategory = this.getSubCategoryById(state.category, nextProps.subCategoryId);
      state.success = true;
      state.error = null;
    }
    // edited categories
    state.validate =
      (this.props.subCategoryId && this.props.subCategoryId !== nextProps.subCategoryId) ||
      nextProps.validate;

    if (!this.state.category && !state.updateCategoriesSection) {
      state.updateCategoriesSection = true;
      state.category = nextProps.categoryId ? this.getCategoryById(nextProps.categoryId) : null;
      state.subCategory = nextProps.subCategoryId
        ? this.getSubCategoryById(state.category, nextProps.subCategoryId)
        : null;
    }

    this.setState(state);
  }

  handleCategoryChange(category) {
    var subCategory = category.subCategories[0];
    this.setState({
      category,
      subCategory,
      isSelected: true,
      //error: 'Please select subcategory', success: null,
      validate: true
    });
    this.editCategories(category.value, subCategory.value);
  }

  handleSubCategory(event) {
    var subCategoryId = parseInt(event.target.value);
    var subCategories = this.state.category.subCategories;
    var selected = subCategories.filter(opt => opt.value === subCategoryId)[0];
    this.setState({
      subCategory: selected,
      error: null,
      success: true,
      validate: true
    });
    var categoryId = this.state.category.value;
    this.editCategories(categoryId, subCategoryId);
  }

  onSubCategoryFocus() {
    var category = this.state.category;
    if (category) {
      var subCategories = category.subCategories;
      var selected = subCategories[0];
      this.setState({
        subCategory: selected,
        error: null,
        success: true,
        validate: true
      });
    } else {
      this.setState({
        error:
          'if trying select sub before main, then show vlidation that says “Please select your main category first',
        validate: true
      });
    }
  }

  editCategories(categoryId, subCategoryId) {
    if (this.props.autoSave) {
      this.props.editSpot(this.props.spotId, {
        category_id: categoryId,
        sub_category_id: subCategoryId
      });
    }
  }

  getCategoryById(categoryId) {
    var categoryArr = categories.filter(category => {
      return category.value === categoryId;
    });
    return categoryArr && categoryArr[0];
  }

  getSubCategoryById(category, subCategoryId) {
    var subCategories = category && category.subCategories;
    var subCategoryArr = subCategories && subCategories.filter(cat => cat.value === subCategoryId);
    return subCategoryArr && subCategoryArr[0];
  }

  isValid() {
    return !!this.state.success;
  }

  render() {
    var subCategories = [];
    var subCategory = this.state.subCategory;
    var selectedText = subCategory ? subCategory.text : 'Select sub category...';
    var value = this.state.isSelected ? this.state.category : DEFAULT_OPTION;
    if (this.state.isSelected) {
      subCategories = this.state.category && this.state.category.subCategories;
    }
    return (
      <div className="categories-selection">
        <SelectInput
          title="Category"
          description="Select the category that best describes the topics on your site."
          onChange={this.handleCategoryChange.bind(this)}
          options={categories}
          error={this.state.validate && this.state.error}
          success={this.state.validate && this.state.success}
          value={value}
        />
        <div className="select-box-large">
          <span className="selected-field">{selectedText}</span>
          <select
            onChange={this.handleSubCategory.bind(this)}
            onFocus={this.onSubCategoryFocus.bind(this)}
          >
            {subCategories &&
              subCategories.map(category => (
                <option key={category.value} value={category.value}>
                  {category.text}
                </option>
              ))}
          </select>
        </div>
      </div>
    );
  }
}

CategoriesInput.propTypes = {
  categoryId: PropTypes.number,
  subCategoryId: PropTypes.number,
  validate: PropTypes.bool,
  autoSave: PropTypes.bool,
  spotId: PropTypes.string
};

CategoriesInput.displayName = displayName;

export default withEditSpot(CategoriesInput);

const categories = [
  {
    value: 1,
    text: 'Arts and Entertainment',
    subCategories: [
      { value: 1, text: 'Animation and Comics' },
      { value: 2, text: 'Architecture' },
      { value: 3, text: 'Awards' },
      { value: 4, text: 'Celebrities and Entertainment news' },
      { value: 5, text: 'Fashion and Modeling' },
      { value: 6, text: 'Humor' },
      { value: 7, text: 'Movies' },
      { value: 8, text: 'Music and Audio' },
      { value: 9, text: 'Performing Arts' },
      { value: 10, text: 'Photography' },
      { value: 11, text: 'TV and Video' },
      { value: 12, text: 'Visual Arts and Design' }
    ]
  },
  {
    value: 2,
    text: 'Autos and Vehicles',
    subCategories: [
      { value: 1, text: 'Automotive Industry' },
      { value: 2, text: 'Automotive News' },
      { value: 3, text: 'Aviation' },
      { value: 4, text: 'Boating' },
      { value: 5, text: 'Car Buying' },
      { value: 6, text: 'Car Rentals' },
      { value: 7, text: 'Makes and Models' },
      { value: 8, text: 'Motorcycles' },
      { value: 9, text: 'Motorsports' },
      { value: 10, text: 'Trains and Railroads' }
    ]
  },
  {
    value: 3,
    text: 'Beauty and Fitness',
    subCategories: [
      { value: 1, text: 'Beauty' },
      { value: 2, text: 'Bodyart' },
      { value: 3, text: 'Cosmetics' },
      { value: 4, text: 'Fitness' },
      { value: 5, text: 'Hair' },
      { value: 6, text: 'Skin Care' },
      { value: 7, text: 'Weight Loss' }
    ]
  },
  {
    value: 4,
    text: 'Books and Literature',
    subCategories: [
      { value: 1, text: 'Book Retailers' },
      { value: 2, text: 'E-Books' },
      { value: 3, text: 'Folklore' },
      { value: 4, text: 'Guides and Reviews' }
    ]
  },
  {
    value: 5,
    text: 'Business and Industry',
    subCategories: [
      { value: 1, text: 'Aerospace and Defence' },
      { value: 2, text: 'Agriculture and Forestry' },
      { value: 3, text: 'Associations' },
      { value: 4, text: 'Biotechnology and Pharmaceuticals' },
      { value: 5, text: 'Business Services' },
      { value: 6, text: 'Chemicals' },
      { value: 7, text: 'Construction and Maintenance' },
      { value: 8, text: 'Customer Service' },
      { value: 9, text: 'E-Commerce' },
      { value: 10, text: 'Energy' },
      { value: 11, text: 'Industrial Goods and Services' },
      { value: 12, text: 'Marketing and Advertising' },
      { value: 13, text: 'Metals and Mining' },
      { value: 14, text: 'Publishing and Printing' },
      { value: 15, text: 'Real Estate' },
      { value: 16, text: 'Textiles and Nonwovens' },
      { value: 17, text: 'Transportation and Logistics' },
      { value: 18, text: 'Wholesale Trade' }
    ]
  },
  {
    value: 6,
    text: 'Career and Education',
    subCategories: [
      { value: 1, text: 'Business Training' },
      { value: 2, text: 'Education' },
      { value: 3, text: 'Human Resources' },
      { value: 4, text: 'Jobs and Employment' },
      { value: 5, text: 'Univerisities and Colleges' }
    ]
  },
  {
    value: 7,
    text: 'Computer and Electronics',
    subCategories: [
      { value: 1, text: 'Computer Hardware' },
      { value: 2, text: 'Computer Security' },
      { value: 3, text: 'Consumer Electronics' },
      { value: 4, text: 'Graphics and Multimedia' },
      { value: 5, text: 'Networking' },
      { value: 6, text: 'Programming' },
      { value: 7, text: 'Software' }
    ]
  },
  {
    value: 8,
    text: 'Finance',
    subCategories: [
      { value: 1, text: 'Accounting' },
      { value: 2, text: 'Banking' },
      { value: 3, text: 'Credit, Loans and Mortgages' },
      { value: 4, text: 'Financial Management' },
      { value: 5, text: 'Grants and Scholarships' },
      { value: 6, text: 'Insurance' },
      { value: 7, text: 'Investing' }
    ]
  },
  {
    value: 9,
    text: 'Food and Drink',
    subCategories: [
      { value: 1, text: 'Beverages' },
      { value: 2, text: 'Catering' },
      { value: 3, text: 'Cooking and Recipes' },
      { value: 4, text: 'Food and Grocery Retailers' },
      { value: 5, text: 'Restaurants and Delivery' },
      { value: 6, text: 'Vegetarian and Vegan' }
    ]
  },
  {
    value: 10,
    text: 'Gambling',
    subCategories: [
      { value: 1, text: 'Bingo' },
      { value: 2, text: 'Casinos' },
      { value: 3, text: 'Lottery' },
      { value: 4, text: 'Poker' },
      { value: 5, text: 'Regulation and Organizations' },
      { value: 6, text: 'Sports' }
    ]
  },
  {
    value: 11,
    text: 'Games',
    subCategories: [
      { value: 1, text: 'Board and Card Games' },
      { value: 2, text: 'Miniatures' },
      { value: 3, text: 'Online' },
      { value: 4, text: 'Puzzles and Brainteasers' },
      { value: 5, text: 'Roleplaying' },
      { value: 6, text: 'Video Games' }
    ]
  },
  {
    value: 12,
    text: 'Health',
    subCategories: [
      { value: 1, text: 'Addictions' },
      { value: 2, text: 'Alternative and Natural Medicine' },
      { value: 3, text: 'Child Health' },
      { value: 4, text: 'Conditions and Diseases' },
      { value: 5, text: 'Dentistry' },
      { value: 6, text: 'Education and Resources' },
      { value: 7, text: 'Healthcare Industry' },
      { value: 8, text: 'Medicine' },
      { value: 9, text: 'Mens Health' },
      { value: 10, text: 'Mental Health' },
      { value: 11, text: 'Nutrition' },
      { value: 12, text: 'Pharmacy' },
      { value: 13, text: 'Products and Shopping' },
      { value: 14, text: 'Public Health and Safety' },
      { value: 15, text: 'Reproductive Health' },
      { value: 16, text: 'Senior Health' },
      { value: 17, text: 'Womens Health' }
    ]
  },
  {
    value: 13,
    text: 'Home and Garden',
    subCategories: [
      { value: 1, text: 'Gardening' },
      { value: 2, text: 'Home Improvement' },
      { value: 3, text: 'Interior Decor' },
      { value: 4, text: 'Moving and Relocating' },
      { value: 5, text: 'Nursery and Playroom' }
    ]
  },
  {
    value: 14,
    text: 'Internet and Telecom',
    subCategories: [
      { value: 1, text: 'Ad Network' },
      { value: 2, text: 'Chats and Forums' },
      { value: 3, text: 'Domain Names and Register' },
      { value: 4, text: 'Email' },
      { value: 5, text: 'File Sharing' },
      { value: 6, text: 'Mobile Developers' },
      { value: 7, text: 'Online Marketing' },
      { value: 8, text: 'Search Engine' },
      { value: 9, text: 'Social Network' },
      { value: 10, text: 'Telecommunications' },
      { value: 11, text: 'Web Design' },
      { value: 12, text: 'Web Hosting' }
    ]
  },
  {
    value: 15,
    text: 'Law and Government',
    subCategories: [
      { value: 1, text: 'Government' },
      { value: 2, text: 'Immigration and Visas' },
      { value: 3, text: 'Law' },
      { value: 4, text: 'Military and Defense' }
    ]
  },
  {
    value: 16,
    text: 'News and Media',
    subCategories: [
      { value: 1, text: 'Business News' },
      { value: 2, text: 'College and University Press' },
      { value: 3, text: 'Magazines and E-Zines' },
      { value: 4, text: 'Newspapers' },
      { value: 5, text: 'Sports News' },
      { value: 6, text: 'Weather' }
    ]
  },
  {
    value: 17,
    text: 'People and Society',
    subCategories: [
      { value: 1, text: 'Crime and Prosecution' },
      { value: 2, text: 'Death' },
      { value: 3, text: 'Disabled and Special Needs' },
      { value: 4, text: 'Gay, Lesbian, and Bisexual' },
      { value: 5, text: 'Genealogy' },
      { value: 6, text: 'History' },
      { value: 7, text: 'Holidays' },
      { value: 8, text: 'Philanthropy' },
      { value: 9, text: 'Philosophy' },
      { value: 10, text: 'Relationships and Dating' },
      { value: 11, text: 'Religion and Spirituality' },
      { value: 12, text: 'Womens Interests' }
    ]
  },
  {
    value: 18,
    text: 'Pets and Animals',
    subCategories: [
      { value: 1, text: 'Animal Products and Service' },
      { value: 2, text: 'Birds' },
      { value: 3, text: 'Fish and Aquaria' },
      { value: 4, text: 'Horses' },
      { value: 5, text: 'Pets' }
    ]
  },
  {
    value: 19,
    text: 'Recreation and Hobbies',
    subCategories: [
      { value: 1, text: 'Antiques' },
      { value: 2, text: 'Camps' },
      { value: 3, text: 'Climbing' },
      { value: 4, text: 'Collecting' },
      { value: 5, text: 'Crafts' },
      { value: 6, text: 'Models' },
      { value: 7, text: 'Nudism' },
      { value: 8, text: 'Outdoors' },
      { value: 9, text: 'Scouting' },
      { value: 10, text: 'Theme Parks' },
      { value: 11, text: 'Tobacco' },
      { value: 12, text: 'Weapons' }
    ]
  },
  {
    value: 20,
    text: 'Reference',
    subCategories: [
      { value: 1, text: 'Archives' },
      { value: 2, text: 'Ask and Expert' },
      { value: 3, text: 'Dictionaries and Encyclopedias' },
      { value: 4, text: 'Directories' },
      { value: 5, text: 'Libraries and Museums' },
      { value: 6, text: 'Maps' }
    ]
  },
  {
    value: 21,
    text: 'Science',
    subCategories: [
      { value: 1, text: 'Agriculture' },
      { value: 2, text: 'Astronomy' },
      { value: 3, text: 'Biology' },
      { value: 4, text: 'Chemistry' },
      { value: 5, text: 'Earth Sciences' },
      { value: 6, text: 'Educational Resources' },
      { value: 7, text: 'Engineering and Technology' },
      { value: 8, text: 'Environment' },
      { value: 9, text: 'Instruments and Supplies' },
      { value: 10, text: 'Math' },
      { value: 11, text: 'Physics' },
      { value: 12, text: 'Social Sciences' }
    ]
  },
  {
    value: 22,
    text: 'Shopping',
    subCategories: [
      { value: 1, text: 'Antiques and Collectibles' },
      { value: 2, text: 'Auctions' },
      { value: 3, text: 'Children' },
      { value: 4, text: 'Consumer Electronics' },
      { value: 5, text: 'Coupons' },
      { value: 6, text: 'Ethnic and Regional' },
      { value: 7, text: 'Flowers' },
      { value: 8, text: 'Furniture' },
      { value: 9, text: 'General Merchandise' },
      { value: 10, text: 'Gifts' },
      { value: 11, text: 'Home and Garden' },
      { value: 12, text: 'Jewelry' },
      { value: 13, text: 'Music' },
      { value: 14, text: 'Office Products' },
      { value: 15, text: 'Publications' },
      { value: 16, text: 'Sports' },
      { value: 17, text: 'Wedding' }
    ]
  },
  {
    value: 23,
    text: 'Sports',
    subCategories: [
      { value: 1, text: 'Baseball' },
      { value: 2, text: 'Basketball' },
      { value: 3, text: 'Boxing' },
      { value: 4, text: 'Cycling and Biking' },
      { value: 5, text: 'Equestrian' },
      { value: 6, text: 'Extreme Sports' },
      { value: 7, text: 'Fantasy Sports' },
      { value: 8, text: 'Fishing' },
      { value: 9, text: 'Football' },
      { value: 10, text: 'Golf' },
      { value: 11, text: 'Martial Arts' },
      { value: 12, text: 'Rugby' },
      { value: 13, text: 'Running' },
      { value: 14, text: 'Soccer' },
      { value: 15, text: 'Tennis' },
      { value: 16, text: 'Volleyball' },
      { value: 17, text: 'Water Sports' },
      { value: 18, text: 'Winter Sports' },
      { value: 19, text: 'Hockey' }
    ]
  },
  {
    value: 24,
    text: 'Travel',
    subCategories: [
      { value: 1, text: 'Accommodation and Hotels' },
      { value: 2, text: 'Airlines and Airports' },
      { value: 3, text: 'Roads and Highways' },
      { value: 4, text: 'Tourism' }
    ]
  }
];
